var _path, _path2, _path3, _path4, _path5, _path6, _circle, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _rect, _circle2, _circle3, _circle4, _path14, _path15, _path16, _path17, _circle5, _path18, _path19, _path20, _path21, _path22, _circle6, _path23, _path24;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnBoardingSvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Gruppe_3282",
    "data-name": "Gruppe 3282",
    xmlns: "http://www.w3.org/2000/svg",
    width: 136,
    height: 115.448,
    viewBox: "0 0 136 115.448",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3542",
    "data-name": "Pfad 3542",
    d: "M827.826,340.341c1.455,2.861,2.6,5.811,5.811,5.811a5.811,5.811,0,1,0,0-11.623C830.376,334.488,825.118,335.016,827.826,340.341Z",
    transform: "translate(-711.947 -300.769)",
    fill: "#2f2e41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3543",
    "data-name": "Pfad 3543",
    d: "M558.186,490.823l-2.484.553-3.317-9.316,3.665-.817Z",
    transform: "translate(-437.74 -381.362)",
    fill: "#a0616a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3544",
    "data-name": "Pfad 3544",
    d: "M827.376,697.9l-8.008,1.785-.023-.1a3.193,3.193,0,0,1,2.422-3.812h0l4.891-1.09Z",
    transform: "translate(-705.76 -586.179)",
    fill: "#2f2e41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3545",
    "data-name": "Pfad 3545",
    d: "M601.542,505.968H599l-1.211-9.815h3.756Z",
    transform: "translate(-473.718 -393.178)",
    fill: "#a0616a"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3546",
    "data-name": "Pfad 3546",
    d: "M860.044,714.612h-8.2v-.1a3.193,3.193,0,0,1,3.193-3.193h5.011Z",
    transform: "translate(-731.571 -599.355)",
    fill: "#2f2e41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3547",
    "data-name": "Pfad 3547",
    d: "M824.105,568.481h-3.248a.938.938,0,0,1-.925-.808L816.988,544.9a.311.311,0,0,0-.609-.038l-1.745,6.5,1.573,14.809a.933.933,0,0,1-.718,1.018l-2.576.594a.938.938,0,0,1-1.1-.629l-4.148-14.4a8.118,8.118,0,0,1-.338-3.268l1.3-12.979.1,0,17.329.835-1.013,30.226a.931.931,0,0,1-.933.9Z",
    transform: "translate(-696.264 -460.834)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_480",
    "data-name": "Ellipse 480",
    cx: 5.098,
    cy: 5.098,
    r: 5.098,
    transform: "translate(116.306 35.301)",
    fill: "#a0616a"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3548",
    "data-name": "Pfad 3548",
    d: "M826.3,428.713h-.051l-17.277-.929a.934.934,0,0,1-.839-1.219l1.367-4.246a27.471,27.471,0,0,0,.726-14.087,8.792,8.792,0,0,1,1.562-7.087,8.662,8.662,0,0,1,6.26-3.455h0l.255-.018a8.753,8.753,0,0,1,9.172,10.035l-1.2,8.089.96,11.909a.934.934,0,0,1-.93,1.009Z",
    transform: "translate(-696.899 -350.796)",
    fill: "#ccc"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3549",
    "data-name": "Pfad 3549",
    d: "M780.852,515.011a2.087,2.087,0,0,0,.326-3.184L784.5,505.2l-3.827.453-2.572,6.225a2.1,2.1,0,0,0,2.747,3.134Z",
    transform: "translate(-672.713 -436.018)",
    fill: "#a0616a"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3550",
    "data-name": "Pfad 3550",
    d: "M895.945,518.412a2.087,2.087,0,0,1,.211-3.193l-2.172-7.092,3.7,1.086,1.5,6.568a2.1,2.1,0,0,1-3.232,2.631Z",
    transform: "translate(-764.968 -438.339)",
    fill: "#a0616a"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3551",
    "data-name": "Pfad 3551",
    d: "M880.652,433.817a.929.929,0,0,1-.925-.811L878,419.967l-2.757-10.189a2.945,2.945,0,0,1,2.77-3.713h0a2.956,2.956,0,0,1,2.975,2.448l4.108,24.064a.934.934,0,0,1-.881,1.09l-3.521.149Z",
    transform: "translate(-750.035 -357.459)",
    fill: "#ccc"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3552",
    "data-name": "Pfad 3552",
    d: "M785.581,429.688a.954.954,0,0,1-.2-.021l-3.447-.735a.934.934,0,0,1-.687-1.222l8.072-23.039a2.961,2.961,0,0,1,3.342-1.917h0a2.945,2.945,0,0,1,2.111,4.124l-4.426,9.6-3.878,12.554A.928.928,0,0,1,785.581,429.688Z",
    transform: "translate(-675.59 -354.794)",
    fill: "#ccc"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3553",
    "data-name": "Pfad 3553",
    d: "M831.247,342.217a6.933,6.933,0,0,0,3.962,1.225,4.25,4.25,0,0,1-1.684.693,13.98,13.98,0,0,0,5.711.032,3.7,3.7,0,0,0,1.2-.411,1.513,1.513,0,0,0,.738-.987,2.04,2.04,0,0,0-1.012-1.8,7.465,7.465,0,0,0-6.273-1.254,3.435,3.435,0,0,0-1.858,1.05,1.692,1.692,0,0,0-.156,2.01Z",
    transform: "translate(-715.252 -304.7)",
    fill: "#2f2e41"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3554",
    "data-name": "Pfad 3554",
    d: "M361.759,171.875H274.174a1.811,1.811,0,0,0-1.81,1.81v85.368a1.811,1.811,0,0,0,1.81,1.81h7.679v-.517h-7.679a1.3,1.3,0,0,1-1.293-1.293V173.685a1.294,1.294,0,0,1,1.293-1.293h87.585a1.3,1.3,0,0,1,1.3,1.293v85.368a1.282,1.282,0,0,1-.214.71,1.337,1.337,0,0,1-.49.44,1.284,1.284,0,0,1-.592.143h-7.679v.517h7.679a1.808,1.808,0,0,0,1.376-.635.4.4,0,0,0,.039-.05,1.692,1.692,0,0,0,.259-.438,1.764,1.764,0,0,0,.137-.687V173.685A1.812,1.812,0,0,0,361.759,171.875Z",
    transform: "translate(-272.364 -171.875)",
    fill: "#3f3d56"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1726",
    "data-name": "Rechteck 1726",
    width: 90.689,
    height: 0.517,
    transform: "translate(0.258 7.254)",
    fill: "#3f3d56"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_481",
    "data-name": "Ellipse 481",
    cx: 1.552,
    cy: 1.552,
    r: 1.552,
    transform: "translate(3.103 2.329)",
    fill: "#3f3d56"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_482",
    "data-name": "Ellipse 482",
    cx: 1.552,
    cy: 1.552,
    r: 1.552,
    transform: "translate(7.566 2.329)",
    fill: "#3f3d56"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_483",
    "data-name": "Ellipse 483",
    cx: 1.552,
    cy: 1.552,
    r: 1.552,
    transform: "translate(12.028 2.329)",
    fill: "#3f3d56"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3555",
    "data-name": "Pfad 3555",
    d: "M420.08,243.927H376.287a2.7,2.7,0,0,1,0-5.4H420.08a2.7,2.7,0,0,1,0,5.4Zm-43.792-4.981a2.283,2.283,0,1,0,0,4.566H420.08a2.283,2.283,0,1,0,0-4.566Z",
    transform: "translate(-352.58 -224.697)",
    fill: "#3f3d56"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3556",
    "data-name": "Pfad 3556",
    d: "M385.617,338.351h-66a3.532,3.532,0,0,1-3.528-3.528v-21.17a3.532,3.532,0,0,1,3.528-3.528h66a3.532,3.532,0,0,1,3.528,3.528v21.17A3.532,3.532,0,0,1,385.617,338.351Zm-66-27.811a3.117,3.117,0,0,0-3.113,3.113v21.17a3.117,3.117,0,0,0,3.113,3.113h66a3.117,3.117,0,0,0,3.113-3.113v-21.17a3.117,3.117,0,0,0-3.113-3.113Z",
    transform: "translate(-307.014 -281.432)",
    fill: "#3f3d56"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3557",
    "data-name": "Pfad 3557",
    d: "M439.487,359.946H416.449a1.66,1.66,0,0,1,0-3.321h23.038a1.66,1.66,0,0,1,0,3.321Z",
    transform: "translate(-385.229 -318.281)",
    fill: "#eee"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3558",
    "data-name": "Pfad 3558",
    d: "M460.864,386.946H416.449a1.66,1.66,0,0,1,0-3.321h44.415a1.66,1.66,0,0,1,0,3.321Z",
    transform: "translate(-385.229 -339.677)",
    fill: "#eee"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_484",
    "data-name": "Ellipse 484",
    cx: 6.226,
    cy: 6.226,
    r: 6.226,
    transform: "translate(13.911 36.58)",
    fill: "#eee"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3559",
    "data-name": "Pfad 3559",
    d: "M608.25,419.446h-5.811a1.66,1.66,0,1,1,0-3.321h5.811a1.66,1.66,0,0,1,0,3.321Z",
    transform: "translate(-532.616 -365.431)",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3560",
    "data-name": "Pfad 3560",
    d: "M608.25,419.446h-5.811a1.66,1.66,0,1,1,0-3.321h5.811a1.66,1.66,0,0,1,0,3.321Z",
    transform: "translate(-532.616 -365.431)",
    fill: "#ccc"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3561",
    "data-name": "Pfad 3561",
    d: "M385.612,494.125h-66a3.533,3.533,0,0,0-3.528,3.528v21.17a3.533,3.533,0,0,0,3.528,3.528h66a3.532,3.532,0,0,0,3.528-3.528v-21.17a3.532,3.532,0,0,0-3.528-3.528Zm3.113,24.7a3.116,3.116,0,0,1-3.113,3.113h-66a3.117,3.117,0,0,1-3.113-3.113v-21.17a3.117,3.117,0,0,1,3.113-3.113h66a3.116,3.116,0,0,1,3.113,3.113Z",
    transform: "translate(-307.01 -427.243)",
    fill: "#3f3d56"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3562",
    "data-name": "Pfad 3562",
    d: "M439.487,543.946H416.449a1.66,1.66,0,0,1,0-3.321h23.038a1.66,1.66,0,0,1,0,3.321Z",
    transform: "translate(-385.229 -464.092)",
    fill: "#eee"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3563",
    "data-name": "Pfad 3563",
    d: "M460.864,570.946H416.449a1.66,1.66,0,0,1,0-3.321h44.415a1.66,1.66,0,0,1,0,3.321Z",
    transform: "translate(-385.229 -485.488)",
    fill: "#eee"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_485",
    "data-name": "Ellipse 485",
    cx: 6.226,
    cy: 6.226,
    r: 6.226,
    transform: "translate(13.911 74.769)",
    fill: "#eee"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3564",
    "data-name": "Pfad 3564",
    d: "M608.25,603.446h-5.811a1.66,1.66,0,1,1,0-3.321h5.811a1.66,1.66,0,1,1,0,3.321Z",
    transform: "translate(-532.616 -511.243)",
    fill: "#ccc"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3565",
    "data-name": "Pfad 3565",
    d: "M814.9,726.54H785.844a.208.208,0,1,1,0-.415H814.9a.208.208,0,0,1,0,.415Z",
    transform: "translate(-679.108 -611.092)",
    fill: "#3f3d56"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnBoardingSvg);
export default __webpack_public_path__ + "static/media/OnBoardingSVG.a3d74de83702449215d0d8ba9d21c032.svg";
export { ForwardRef as ReactComponent };